import { useState, useEffect } from "react";

import { useRouter } from "src/routes/hooks";

import { SplashScreen } from "src/components/loading-screen";

import { useSelector } from "react-redux";
import { persistor, RootState } from "src/store/store";

// ----------------------------------------------------------------------

type AuthGuardProps = {
  children: React.ReactNode;
};

export function AuthGuard({ children }: AuthGuardProps) {
  const router = useRouter();
  const { isAuthenticated, token } = useSelector(
    (state: RootState) => state.auth
  );
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (persistor.getState().bootstrapped) {
      setChecked(true);
      return;
    }

    const unsubscribe = persistor.subscribe(() => {
      const { bootstrapped } = persistor.getState();
      if (bootstrapped) {
        setChecked(true);
        unsubscribe();
      }
    });
    return () => unsubscribe();
  }, []);
  useEffect(() => {
    // if (
    //   checked &&
    //   (!isAuthenticated || !token || !localStorage.getItem("token"))
    // ) {
    if (checked && (!isAuthenticated || !token)) {
      console.log("Redirecting to login due to missing token...");
      router.replace("/login");
    }
  }, [checked, isAuthenticated, token, router]);

  useEffect(() => {
    const handleStorage = (event: StorageEvent) => {
      if (event.key === "persist:root") {
        const newPersistRoot = event.newValue;
        if (newPersistRoot) {
          const parsed = JSON.parse(newPersistRoot);
          const authState = JSON.parse(parsed.auth || "{}");

          // Check if token is removed in another tab
          if (!authState.token || !authState.isAuthenticated) {
            console.log("Token removed in another tab. Forcing logout...");
            router.replace("/login");
            // window.location.reload();
          }
        }
      }
    };

    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, [router]);

  if (!checked) {
    return <SplashScreen />;
  }
  if (!isAuthenticated) {
    return <SplashScreen />;
  }

  return <>{children}</>;
}
